import createIcon from "../createIcon";
import React from "react";

export const ArrowLeftIcon = createIcon({
  path: (
    <path
      d="M29.4209 13.4209C28.6409 12.6409 27.3809 12.6409 26.6009 13.4209L17.4209 22.6009C16.6409 23.3809 16.6409 24.6409 17.4209 25.4209L26.6009 34.6009C27.3809 35.3809 28.6409 35.3809 29.4209 34.6009C30.2009 33.8209 30.2009 32.5609 29.4209 31.7809L21.6609 24.0009L29.4209 16.2409C30.2009 15.4609 30.1809 14.1809 29.4209 13.4209Z"
      fill="currentColor"
    />
  )
});

export default ArrowLeftIcon;
